import Logo from "./assets/logo_koin.png";
import Kin from "./assets/logo_kin.png";

console.log('\n\n\n NODE ENV \n\n\n', process.env.NODE_ENV);

const IS_LOCAL = process.env.NODE_ENV === 'none';
const BOT_NAME = 'koin'; 
const isProduction = process.env.NODE_ENV === 'production';
const HTTP_BASE = IS_LOCAL ? 'http://' : 'https://'
const BASE_URL = isProduction ? `${BOT_NAME}` : `staging.${BOT_NAME}`
const URL = IS_LOCAL ? `localhost:8445` : `${BASE_URL}.elife.com.br`

//const WEBSOCKET_BASE = 'wss'
//const BASE_URL = 'staging.{NOME_BOT}'

export default {
  agent: {
    displayName: "Assistente virtual",
    kinUri: Kin,
    avatarUri: Logo,
    description:
      "Olá, eu sou o assistente da Koin Clique aqui!"
  },
  app: {
    websocket: `wss://${URL}/websocket/client/:session_id`,
    gateway: `${HTTP_BASE}${URL}/dialog/interact/`,
    cancel: `${HTTP_BASE}${URL}/dialog/attendances`,
    base: `https://${BASE_URL}.elife.com.br`,
    muted: true, // <- mute microphone at start
    start_suggestions: [], // <- array of suggestions, displayed at the start screen
    fallback_lang: "pt" // <- fallback language code, if history mode or network is unavailable
  },
  i18n: {
    pt: {
      defaultSuggestions: ["Menu inicial"],
      callToAction: "Começar",
      welcomeTitle: "Koin",
      cancel: ["Encerrar atendimento"],
      muteTitle: "Alterar acessibilidade",
      inputTitle: "Digite sua mensagem",
      sendTitle: "Enviar",
      microphoneTitle: "Falar"
    }
  }

};